import { createSlice } from "@reduxjs/toolkit";
import proj4 from "proj4";
import { register } from "ol/proj/proj4";
import { PROJECTION_REF_SYSTEMS } from "../../consts/projections";

proj4.defs(
  PROJECTION_REF_SYSTEMS.EPSG_5514,
  "+proj=krovak +lat_0=49.5 +lon_0=24.83333333333333 +alpha=30.28813972222222 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=589,76,480,0,0,0,0 +units=m +no_defs",
);
register(proj4);

const initialState = {
  projection: PROJECTION_REF_SYSTEMS.EPSG_5514,
  czechExtent: [-910000, -1230000, -430000, -930000],
  defaultCenter: [-670000, -1080000],
  defaultZoom: 10,
};

const mapConfigSlice = createSlice({
  name: "mapConfig",
  initialState,
  reducers: {
    setProjection: (state, action) => {
      state.projection = action.payload;
    },
    setExtent: (state, action) => {
      state.czechExtent = action.payload;
    },
  },
});

export const { setProjection, setExtent } = mapConfigSlice.actions;
export default mapConfigSlice.reducer;
